import { render, staticRenderFns } from "./reject_reasons.vue?vue&type=template&id=33b97557&scoped=true&"
import script from "./reject_reasons.vue?vue&type=script&lang=js&"
export * from "./reject_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b97557",
  null
  
)

export default component.exports